import { SearchConfig } from '@/components/page-model/typing';
import { reactive } from 'vue';
import { RuleObject } from 'ant-design-vue/lib/form/interface';
import moment from 'moment';
import { config } from '@/components/page-model/mjstore/mjstore-customer-config';
import pinyin from 'pinyin';

export default (current_org: any, current_shop: any) => {
  const None = null;
  const True = true;
  const False = false;

  const update_model_config = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'input',
        name: 'name',
        label: '会员姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员姓名',
      },
      {
        type: 'input',
        name: 'pinyin',
        label: '拼音',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写拼音',
      },
      {
        type: 'datepicker',
        name: 'join_date',
        label: '建档日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        showTime: false,
        placeholder: '请填写建档日期',
      },
      {
        type: 'radio',
        name: 'gender',
        label: '性别',
        disabled: false,
        allowClear: true,
        labelKey: 'name',
        valueKey: 'value',
        defaultValue: '',
        placeholder: '请选择性别',
      },
      {
        type: 'datepicker',
        name: 'birthday',
        label: '生日',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        showTime: false,
        placeholder: '请填写生日',
      },
      {
        type: 'input',
        name: 'phone',
        label: '电话',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写电话',
      },
      {
        type: 'remoteselect',
        name: 'hk_type_id',
        label: '获客方式',
        disabled: false,
        placeholder: '请选择获客方式',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-hktype',
      },
      {
        type: 'remoteselect',
        name: 'adviser_id',
        label: '所属顾问',
        disabled: false,
        placeholder: '请选择所属顾问',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
    ],
    rules: {
      phone: [{ pattern: /^1[3456789]\d{9}$/, message: '请填输入正确的电话号' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      name: null,
      join_date: null,
      gender: null,
      birthday: null,
      phone: null,
      shop_id: null,
      hk_type_id: null,
      adviser_id: null,
      pinyin: null,
    }),
  };
  const update_model_config_options = {
    gender: [
      { value: 0, name: '女' },
      { value: 1, name: '男' },
    ],
  };

  return {
    update_model_config: update_model_config,
    update_model_config_options: update_model_config_options,
  };
};
